import { alpha, Box, Stack, Typography, useTheme } from "@mui/material";
import { forwardRef } from "react";

type Props = {
	image: string;
	category: string;
	title: string;
	subtitle: string;
};

export const InspirationDetailHero = forwardRef<HTMLDivElement, Props>(
	({ image, category, title, subtitle }, ref) => {
		const theme = useTheme();

		return (
			<Box
				ref={ref}
				position="relative"
				height={`calc(${theme.inspiration.hero.height}px + var(--mobile-safe-area-top, 0px))`}
				overflow="hidden"
				mt="calc(-1 * var(--mobile-safe-area-top, 0px))"
				bgcolor={theme.palette.grey[200]}
			>
				<Box
					component="img"
					src={image}
					alt=""
					position="absolute"
					width="100%"
					height="100%"
					sx={{ inset: 0, objectFit: "cover" }}
				/>
				<Box
					position="absolute"
					sx={{
						inset: 0,
						background: theme.inspiration.hero.overlayGradient,
					}}
				/>
				<Stack
					position="absolute"
					left={0}
					right={0}
					bottom={0}
					px={1.6}
					pb={1.6}
				>
					<Typography
						component="span"
						fontSize="12px"
						fontWeight={500}
						color={alpha(theme.palette.darkmodeText.white, 0.7)}
					>
						{category}
					</Typography>
					<Typography
						component="h1"
						fontSize="20px"
						fontWeight={700}
						lineHeight={1.25}
						color={theme.palette.darkmodeText.white}
					>
						{title}
					</Typography>
					<Typography
						fontSize="14px"
						mt={0.5}
						color={alpha(theme.palette.darkmodeText.white, 0.8)}
					>
						{subtitle}
					</Typography>
				</Stack>
			</Box>
		);
	},
);
